import { render, staticRenderFns } from "./ShowCode.vue?vue&type=template&id=879ce728&"
import script from "./ShowCode.vue?vue&type=script&lang=js&"
export * from "./ShowCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ef2/Projecten/vue-components/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('879ce728')) {
      api.createRecord('879ce728', component.options)
    } else {
      api.reload('879ce728', component.options)
    }
    module.hot.accept("./ShowCode.vue?vue&type=template&id=879ce728&", function () {
      api.rerender('879ce728', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/ShowCode.vue"
export default component.exports